import { connect } from "react-redux";

import { deleteBlock } from "../../../../actions/blocks";
import { hideModal } from "../../../../actions/modals";
import { showToast } from "../../../../actions/toasts";
import { putCeremonies } from "../../../../actions/ceremonies";
import { putNormalizedEntities } from "../../../../helpers";
import { getCeremonyBlockWithAssetsById } from "../../../../selectors/blocks";

import VideoUploadModalContainer from "./VideoUploadModalContainer";

const mapStateToProps = (state, props) => {
    const ceremonyId = parseInt(props.ceremonyId);
    const blocks = Object.values(state.entities.blocks.byId).filter(
        block => block.ceremonyId === ceremonyId
    );
    const block = getCeremonyBlockWithAssetsById(state, {
        ceremonyId,
        blockId: props.blockId
    });

    return {
        isEditing: Boolean(props.blockId),
        isVisible: true,
        blocks,
        block,
        ceremony: state.entities.ceremonies.byId[ceremonyId]
    };
};

const mapDispatchToProps = dispatch => {
    return {
        hideModal: () => dispatch(hideModal()),
        onBlockDeleted: id => dispatch(deleteBlock(id)),
        showToast: options => dispatch(showToast(options)),
        onUpdatedCeremony: ceremony => dispatch(putCeremonies([ceremony])),
        updateStoreEntities: entities =>
            putNormalizedEntities(dispatch, entities)
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(VideoUploadModalContainer);
